///////////////////////////////////////////////////

import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { limitOrderInputFormActions } from 'state/secondaryMarket/limit-order/form/input/inputForm.actions';
import type { EpicWithThunk } from 'state/state.common';

import { getTabRemoved$ } from '../utils';

export function persistLimitOrderTabContentEpic(): EpicWithThunk {
  return (actions$, _, { httpClient }) => {
    const { updateTabContent } = tabsApiConnector(httpClient, 'secondaryMarketPostEvents');
    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_TAB_CONTENT_PERSISTENCE_REQUESTED'),
      filter(({ workspace }) => workspace === 'secondaryMarketPostEvents'),
      mergeMap(({ tabId, tabContent }) => {
        return updateTabContent(tabId, tabContent).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(() => limitOrderInputFormActions.tabContentPersisted(tabId, 'secondaryMarketPostEvents')),
          catchError(() => EMPTY),
        );
      }),
    );
  };
}
